import authSlice from './auth-slice'

export const { setAuthState, logoutUser } = authSlice.actions
